import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import ResponsiveGatekeeper from './ResponsiveGatekeeper';
import { CssBaseline } from '@mui/material';
import LandingPage from './Components/Landingpage/Landingpage';
import LoginScreen from './Components/Login/Login';
import HomeScreen from './Components/HomePage/HomePage';
import CheckinScreen from './Components/checkin/checkin';
import RoomListScreen from './Components/RoomList/RoomList';
import RoomUnlockScreen from './Components/RoomList/RoomUnlock';
import UnlockSuccessScreen from './Components/RoomList/UnlockSuccessScreen';
import TopPicksScreen from './Components/TopPicks/TopPicksScreen';
import OrderScreen from './Components/OrderScreen/OrderScreen';
import OrderPlaced from './Components/OrderScreen/OrderPlacedSucess';
import SubCategoryScreen from './Components/RoomUpgrade/subcategory';
import ResetPasswordScreen from './Components/ResetPassword/ResetPasswordScreen';
// import LaunchPage from './Components/LaunchPage/LaunchPage';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);

function App() {
  return (
    <ResponsiveGatekeeper>
      <CssBaseline />
      <Router>
        <Routes>
          {/* <Route path="/" element={<LaunchPage />} /> */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<LoginScreen />} />
          <Route path="/reset-password/:token" element={<ResetPasswordScreen />} />

          <Route
            path="/home"
            element={
                <HomeScreen />
            }
          />
          <Route
            path="/checkin/:reservationID"
            element={
                <CheckinScreen />
            }
          />
          <Route
            path="/rooms/:reservationId"
            element={
                <RoomListScreen />
            }
          />
          <Route
            path="/unlock-room"
            element={
                <RoomUnlockScreen />
            }
          />
          <Route
            path="/unlock-success"
            element={
                <UnlockSuccessScreen />
            }
          />
          <Route
            path="/top-picks"
            element={
                <TopPicksScreen />
            }
          />
          <Route
            path="/order/:id"
            element={
                <Elements stripe={stripePromise}>
                  <OrderScreen />
                </Elements>
            }
          />
          <Route
            path="/order-success"
            element={
                <OrderPlaced />
            }
          />
          <Route
            path="/category/:categoryId"
            element={
                <SubCategoryScreen />
            }
          />
        </Routes>
      </Router>
    </ResponsiveGatekeeper>
  );
}

export default App;